import { useEffect } from 'react';
import { useIntl } from '@leagueplatform/locales';
import { EVENT_NAME } from '@leagueplatform/analytics';
import { StepScreen } from 'components/step-screen/step-screen.component';
import { STEP_STRING_IDS } from 'components/onboarding-account-setup/onboarding-account-setup.constants';
import { useStepNavigation } from 'components/stepper/stepper.component';
import {
  useOnboardingFormActions,
  useOnboardingFormState,
} from 'components/onboarding-account-setup/contexts/onboarding-form.context';
import { ANALYTICS_DETAILS, ANALYTICS_SCREEN_NAMES } from 'common/constants';
import { useOnboardingAnalytics } from 'hooks/use-onboarding-analytics/use-onboarding-analytics.hook';
import { PersonalInformationInput } from './personal-information-input.component';

export const PersonalInformationStep = () => {
  const { formatMessage } = useIntl();
  const { goToNextStep } = useStepNavigation();
  const {
    formState: { personalInformation, personalInformationErrors },
    setUserProfileStatus: { isPending },
  } = useOnboardingFormState();
  const { handlePersonalInformationChange, validatePersonalInformation } =
    useOnboardingFormActions();

  const trackEvent = useOnboardingAnalytics(
    ANALYTICS_SCREEN_NAMES.ACCOUNT_SETUP_PROFILE_INFORMATION,
  );

  useEffect(() => {
    trackEvent(EVENT_NAME.SCREEN_LOADED);
  }, [trackEvent]);

  const handleSubmit = () => {
    if (validatePersonalInformation()) {
      trackEvent(EVENT_NAME.BUTTON_CLICKED, {
        detail: ANALYTICS_DETAILS.CONTINUE,
      });
      goToNextStep();
    }
  };

  return (
    <StepScreen
      heading={formatMessage({
        id: STEP_STRING_IDS.personalInformation.heading,
      })}
      subHeading={formatMessage({
        id: STEP_STRING_IDS.personalInformation.subHeading,
      })}
      primaryButton={{
        label: formatMessage({
          id: STEP_STRING_IDS.personalInformation.primaryButtonLabel,
        }),
        onClick: handleSubmit,
        isButtonLoading: isPending,
      }}
    >
      <PersonalInformationInput
        onChange={handlePersonalInformationChange}
        value={personalInformation}
        errors={personalInformationErrors}
      />
    </StepScreen>
  );
};
